export default "__VITE_ASSET__47423150__"